// src/reducers/authReducer.js
import { createSlice } from "@reduxjs/toolkit";


const savedAuth = JSON.parse(localStorage.getItem("auth"));

const initialState = {
  isAuthenticated: !!savedAuth?.token,
  user: savedAuth?.user || null,
  token: savedAuth?.token || null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess(state, action) {
      state.isAuthenticated = true;
      state.user = action.payload.user;
      state.token = action.payload.token;
    },
    logout(state) {
      state.isAuthenticated = false;
      state.user = null;
      state.token = null;
      localStorage.removeItem("auth");
    }
  },
});

export const { loginSuccess, logout } = authSlice.actions;
export default authSlice.reducer;